import { Container, useMediaQuery } from "@mui/material";
import React, { memo, useState, useCallback, Suspense } from "react";
import { Outlet } from "react-router";
import Sidebar from "../../components/Sidebar";
import MobileMenuToggle from "../../components/MobileMenuToggle";
import "./UserLayout.css";
import RouteLoading from "../../components/Loaders/RouteLoading";

const UserLayout = ({ isLoading }) => {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    const saved = localStorage.getItem('sidebarOpen');
    return saved !== null ? saved === 'true' : false;
  });

  const isMobile = useMediaQuery("(max-width: 768px)");

  const handleSetSidebarOpen = useCallback((valOrFn) => {
    setSidebarOpen((prev) => {
      const newVal = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
      localStorage.setItem('sidebarOpen', String(newVal));
      return newVal;
    });
  }, []);

  const toggleSidebar = useCallback(() => {
    handleSetSidebarOpen((prev) => !prev);
  }, [handleSetSidebarOpen]);

  return (
    <div className="user-layout-container">
      {isLoading && <RouteLoading />}
      <MobileMenuToggle onClick={toggleSidebar} isOpen={sidebarOpen} />

      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={handleSetSidebarOpen} isMobile={isMobile} />
      {isMobile && sidebarOpen && (
        <div className="mobile-overlay" onClick={() => handleSetSidebarOpen(false)} />
      )}

      <main className={`content-section${sidebarOpen ? ' sidebar-open' : ' sidebar-collapsed'}`}>
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            minHeight: 0,
          }}
        >
          <Suspense fallback={<RouteLoading />}>
            <Outlet />
          </Suspense>
        </Container>

      </main>
    </div>
  );
};

export default memo(UserLayout);
